<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { cardKey } from "@/components/StickyNote/injectKeys";
import { riskTitle, riskTypeName } from "@/model/baseTypes";
import { injectStrict } from "@/utils/vue";

import AttributeChip from "../AttributeChip.vue";
import ROAMSticky from "./internal/ROAMSticky.vue";

const card = injectStrict(cardKey);

const { t } = useI18n();

const cardRisk = computed(() =>
  card.risk ? t(riskTypeName(card.risk)) : t("risk.roam.ariaLabel.notSet"),
);
const triggerAriaLabel = computed(() => t("risk.roam.ariaLabel", { riskTypeName: cardRisk.value }));
</script>

<template>
  <AttributeChip
    name="roam-chip"
    :text="card.risk"
    :text-placeholder="$t('risk.roam')"
    :dropdown-props="{ width: 'auto' }"
    :tooltip="card.risk ? $t(riskTitle(card.risk)) : $t('risk.roam')"
    :trigger-aria-label
  >
    <ROAMSticky />
  </AttributeChip>
</template>
